import Resource from './Resource';

export default class {
    constructor() {
        this.Resource = new Resource()
    }

    async getGAAuthUrl () {
        return await this.Resource.gaAuthUrl()
    }

    async connectGoogle (code) {
        return await this.Resource.connectGoogle(code)
    }

    async googleGetProfiles () {
        return await this.Resource.googleGetProfiles()
    }

    async connectGoogleAnalyticsOAuthIntegration (websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await this.Resource.connectGoogleAnalyticsOAuthIntegration(websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions)
    }

    async updateGoogleAnalyticsOAuthIntegration (websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await this.Resource.updateGoogleAnalyticsOAuthIntegration (websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions)
    }

    async disconnectGoogleAnalyticsOAuthIntegration (websiteId) {
        return await this.Resource.disconnectGoogleAnalyticsOAuthIntegration (websiteId)
    }

    async removeGoogle (websiteId) {
        return await this.Resource.removeGoogle(websiteId)
    }
}
